$(document).ready(function () {
    $('#dataTableBuilder').on('draw.dt', function(){
        $('.receptionModalLabel').on('show.bs.modal', function (e) {
            // Get value set in data Id
            const id = $(this).data('id');
            // Get the list
            const list = $(this).find('ul');
            let listchildren = list.find('li').length;
            if(id){
                $.ajax({
                    url: route('enteteCommandes.fournisseurs', id),
                    type: 'GET',
                    success: function(data){
                        if (data.length && listchildren != data.length) {
                            // Vidage de la liste
                            if(listchildren){
                                list.innerHTML = '';
                            }
                            // Remplissage de la liste
                            data.forEach(element => {
                                // List
                                let li = document.createElement('li');
                                li.className = "list-group-item d-flex justify-content-between align-items-center";

                                let liText = document.createTextNode(element.name + ' - ' + element.number);
                                li.appendChild(liText);

                                // Link
                                let dl = document.createElement('a');
                                dl.className = "btn btn-secondary bc-download"
                                dl.href = route('enteteCommandes.delivery', {id: id, fournisseur: element.id})
                                dl.innerHTML = "<i class='fas fa-download'></i> Télécharger le BC";

                                // Rattacher
                                li.appendChild(dl);
                                list.append(li);
                                if (window.location.pathname == '/saisieCommandes')
                                    dl.addEventListener('click', function() {
                                        $('.receptionModalLabel').on('hide.bs.modal', function() {
                                            location.reload();
                                        });
                                    });
                                });
                            }
                        },
                        error: function (e){
                            console.log(e.status + ' : ' + e.responseText);
                        }
                    });
                }
            });
        });
    });